import CryptoJS from "crypto-js";

const SECRET_KEY = import.meta.env.VITE_MEETING_SECRET!;

export const encryptObject = (data: object): string => {
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY,
  ).toString();

  return encodeURIComponent(encrypted);
};

// Same as Node.js:
const KEY = CryptoJS.SHA256(SECRET_KEY);

export const decryptObject = (token: string) => {
  try {
    const decoded = decodeURIComponent(token);

    const [ivBase64, encryptedBase64] = decoded.split(":");

    if (!ivBase64 || !encryptedBase64) {
      throw new Error("Invalid token");
    }

    const iv = CryptoJS.enc.Base64.parse(ivBase64);
    const ciphertext = CryptoJS.enc.Base64.parse(encryptedBase64);

    const decrypted = CryptoJS.AES.decrypt(
      {
        ciphertext,
      } as any,
      KEY,
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      },
    );

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  } catch (err) {
    console.error(err);
    return null;
  }
};
